<template>
    <v-card class="main-card">
        <dropdown
                icon="fal fa-calendar"
                :label="'Period' | t"
                type="daterange"
                :value="filterDates"
                :format-emit="false"
                @select="updateFilter($event, 'periodRange')"
        />

        <template v-if="firstLoadingDone">
            <div>
                <v-row no-gutters>
                    <v-col cols="12">
                        <RadioButton
                                :label="'Year/Month' | t"
                                :buttonValue="'year-month'"
                                v-model="groupByPeriodSync"
                        />
                    </v-col>
                    <v-col cols="12">
                        <RadioButton :label="'Year/Week' | t" :buttonValue="'year-week'" v-model="groupByPeriodSync"/>
                    </v-col>
                    <v-col cols="12">
                        <RadioButton :label="'Year/Day' | t" :buttonValue="'year-day'" v-model="groupByPeriodSync"/>
                    </v-col>
                </v-row>
            </div>

            <dropdown
                    :loading="dataLoading"
                    :value="filters.categoryIds"
                    :items="categoryOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-layer-group"
                    :label="'Category' | t"
                    type="multiple"
                    @select="updateFilter($event, 'categoryIds')"
                    @remove="handleRemove($event,'categoryIds')"
            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.brandIds"
                    :items="brandOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-tag"
                    :label="'Brand' | t"
                    type="multiple"
                    @select="updateFilter($event, 'brandIds')"
                    @remove="handleRemove($event,'brandIds')"

            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.productCodes"
                    :items="productOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-hashtag"
                    :label="'Product name' | t"
                    type="multiple"
                    @select="updateFilter($event, 'productCodes')"
                    @remove="handleRemove($event,'productCodes')"

            />
            <dropdown
                    :loading="dataLoading"
                    :value="filters.netoWeights"
                    :items="netoWeightOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-weight-hanging"
                    :label="'Neto weight' | t"
                    type="multiple"
                    @select="updateFilter($event, 'netoWeights')"
                    @remove="handleRemove($event,'netoWeights')"

            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.productProductionTypes"
                    :items="productionProductTypeOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-chart-pie"
                    :label="'Intermediate or finished product' | t"
                    type="multiple"
                    @select="updateFilter($event, 'productProductionTypes')"
                    @remove="handleRemove($event,'productProductionTypes')"

            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.lineNumbers"
                    :items="lineNumberOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-conveyor-belt-alt"
                    :label="'Line number' | t"
                    type="multiple"
                    @select="updateFilter($event, 'lineNumbers')"
                    @remove="handleRemove($event,'lineNumbers')"
            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.operatorNames"
                    :items="operatorOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-user-hard-hat"
                    :label="'Operator' | t"
                    type="multiple"
                    @select="updateFilter($event, 'operatorNames')"
                    @remove="handleRemove($event,'operatorNames')"
            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.lineWorkerNames"
                    :items="lineWorkerOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-user"
                    :label="'Line worker' | t"
                    type="multiple"
                    @select="updateFilter($event, 'lineWorkerNames')"
                    @remove="handleRemove($event,'lineWorkerNames')"
            />

            <dropdown
                    :loading="dataLoading"
                    :value="filters.shifts"
                    :items="shiftOptions"
                    item-text="text"
                    item-value="value"
                    icon="fal fa-clock"
                    :label="'Shift' | t"
                    type="multiple"
                    @select="updateFilter($event, 'shifts')"
                    @remove="handleRemove($event,'shifts')"
            />
        </template>
        <div class="action-bar">
            <span class="reset-text" :class="{ disabled: dataLoading }" @click="resetFilters">
                {{ "Reset" | t }}
            </span>

            <button
                    class="apply-btn"
                    :disabled="dataLoading"
                    @click="handleApplyFilters"
                    :class="{ loading: dataLoading, disabled: dataLoading }"
            >
                <span> {{ "Apply" | t }} </span>
            </button>
        </div>

    </v-card>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import DateRangeInput from "@/components/input/date-range-input.vue";
import Dropdown from "@/components/dropdown/dropdown.vue";
import RadioButton from "@/components/input/radio-button.vue";

export default {
    name: "filters-card",
    components: {
        RadioButton,
        Dropdown,
        DateRangeInput,
        DatePicker,
    },
    data() {
        return {};
    },
    async mounted() {
        const now = new Date();
        const initDates = {
            start: new Date(now.getFullYear(), 0, 1),
            end: now,
        };
        this.updateFilter(initDates, "periodRange");
    },
    methods: {
        ...mapActions("ProductionAnalysisStore", ["fetchData", "generateChartData", "generateTimelineChartData"]),
        ...mapMutations("ProductionAnalysisStore", [
            "updateFilters",
            "setFilterDates",
            "setGroupByPeriod",
            "resetFilters",
            "setDatesChanged",
        ]),
        updateFilter(value, filter) {
            if (filter === "periodRange") {
                this.setFilterDates(value);
                this.setDatesChanged(true);
                return;
            }
            if (filter === "groupByPeriod") {
                this.setGroupByPeriod(value);
                return;
            }
            this.updateFilters({ filter, value });
        },
        handleRemove(value, field) {
            const current = this.filters[field] || [];
            const updated = current.filter((v) => v !== value);
            this.updateFilters({ filter: field, value: updated });
        },
        async handleApplyFilters() {
            if (this.datesChanged) {
                await this.fetchData()
                await this.updateFilter(["finished"], 'productProductionTypes')
            }
            this.generateChartData()
            this.generateTimelineChartData()
        }
    },
    computed: {
        ...mapState("ProductionAnalysisStore", [
            "filters",
            "dataLoading",
            "datesChanged",
            "firstLoadingDone",
            "filterDates",
            "groupByPeriod",
        ]),
        groupByPeriodSync: {
            get() {
                return this.groupByPeriod;
            },
            set(value) {
                this.updateFilter(value, "groupByPeriod");
            },
        },
        ...mapGetters("ProductionAnalysisStore", [
            "netoWeightOptions",
            "categoryOptions",
            "brandOptions",
            "lineNumberOptions",
            "operatorOptions",
            "lineWorkerOptions",
            "productOptions",
            "shiftOptions",
            "productionProductTypeOptions"
        ]),
    },
};
</script>
<style scoped>
.action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
}

.reset-text {
    color: #f41823;
    text-decoration: underline;
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
    cursor: pointer;
}

.apply-btn {
    background-color: #f41823;
    color: white;
    height: 100%;
    border-radius: 8px;
    padding: 7px 16px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
    cursor: pointer;
    border: none;
    min-width: 68px;
}

.apply-btn.disabled {
    background-color: rgba(100, 100, 100, 1);
    cursor: default;
}

.reset-text.disabled {
    color: gray;
    cursor: default;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loader-icon {
    color: white;
    font-size: 20px;
    animation: spin 1s linear infinite;
}

.main-card {
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>
